import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

export default function PaginationRounded(props: any) {
  const { totalCount, handleSubmit } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage);
    handleSubmit(event, newPage, rowsPerPage);
  };
  return (
    <Stack spacing={2}>
      <Pagination
        count={Math.ceil(totalCount / rowsPerPage)}
        page={page + 1}
        onChange={(event, value) => handlePageChange(event, value - 1)}
        variant="outlined"
        shape="rounded" />
    </Stack>
  );
}
